export default __webpack_public_path__ + "static/media/play.3f8c9921.svg";